/* ============================================================
   BRUMA — Kit Dawn (interactions)
   Charger une fois dans layout/theme.liquid, avant </body> :
   {{ 'bruma.js' | asset_url | script_tag }}
   ============================================================ */
(function () {
  "use strict";

  function init() {
    /* ---------- Apparitions douces au scroll ---------- */
    var reveals = document.querySelectorAll(".bruma .reveal");
    if ("IntersectionObserver" in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("in"); });
    }

    /* ---------- Comparatif avant / après (curseur) ---------- */
    var slider = document.getElementById("compareSlider");
    if (slider) {
      var before = document.getElementById("compareBefore");
      var handle = document.getElementById("compareHandle");
      var dragging = false;
      function setPos(clientX) {
        var r = slider.getBoundingClientRect();
        var p = (clientX - r.left) / r.width;
        p = Math.max(0.04, Math.min(0.96, p));
        var pct = (p * 100).toFixed(2);
        before.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
      }
      slider.addEventListener("pointerdown", function (e) { dragging = true; setPos(e.clientX); });
      window.addEventListener("pointermove", function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener("pointerup", function () { dragging = false; });
      before.style.clipPath = "inset(0 50% 0 0)";
    }

    /* ---------- Défilement continu (bandeau) réutilisable ---------- */
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function marquee(rail, opts) {
      opts = opts || {};
      if (!rail || rail.children.length === 0) return null;
      if (reduce) return null; /* respecte la préférence d'animation réduite */
      rail.style.scrollSnapType = "none";
      var speed = opts.speed || 55;               /* px / seconde */
      var d = opts.dir === "rtl" ? -1 : 1;
      /* dupliquer une fois pour une boucle sans couture */
      var base = Array.prototype.slice.call(rail.children);
      base.forEach(function (el) { rail.appendChild(el.cloneNode(true)); });
      function half() { return rail.scrollWidth / 2; }
      if (d < 0) rail.scrollLeft = half();
      var paused = false, last = 0, raf = null, running = false;
      function frame(ts) {
        if (!last) last = ts;
        var dt = (ts - last) / 1000; last = ts;
        if (dt > 0.1) dt = 0.1;
        if (!paused) {
          rail.scrollLeft += d * speed * dt;
          var h = half();
          if (rail.scrollLeft >= h) rail.scrollLeft -= h;
          else if (rail.scrollLeft <= 0) rail.scrollLeft += h;
        }
        raf = requestAnimationFrame(frame);
      }
      function start() { if (running) return; running = true; last = 0; raf = requestAnimationFrame(frame); }
      function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = null; }
      if (opts.pauseHover !== false) {
        rail.addEventListener("mouseenter", function () { paused = true; });
        rail.addEventListener("mouseleave", function () { paused = false; });
      }
      if ("IntersectionObserver" in window) {
        var io3 = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0 });
        io3.observe(rail);
      } else { start(); }
      return { pause: function () { paused = true; }, resume: function () { paused = false; } };
    }

    /* ---------- Carrousel photos (section images) ---------- */
    var vRail = document.getElementById("videoRail");
    if (vRail) { marquee(vRail, { speed: 55, pauseHover: true }); }

    /* ---------- Carrousel Plantes (flèches manuelles) ---------- */
    var pRail = document.getElementById("plantsRail");
    if (pRail) {
      var pTile = pRail.querySelector(".plant-tile");
      var pStep = pTile ? pTile.getBoundingClientRect().width + 18 : 280;
      var pPrev = document.getElementById("plantsPrev");
      var pNext = document.getElementById("plantsNext");
      if (pPrev) pPrev.addEventListener("click", function () { pRail.scrollBy({ left: -pStep * 2, behavior: "smooth" }); });
      if (pNext) pNext.addEventListener("click", function () { pRail.scrollBy({ left: pStep * 2, behavior: "smooth" }); });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
